<template>
  <div v-if="roleModels.length > 0 && !isLoading" class="row section-role-models">
    <div class="col-12">
      <div class="card card-role-models">
        <div class="card-body">
          <h3 class="card-title text-center">
            <strong>Nómadas Roles Models {{ formattedMonth }}</strong>
          </h3>

          <div class="row">
            <div v-for="role in roleModels" :key="role.id" class="col-12 col-md-6">
              <div class="role-model-item p-3">
                <!-- Role Model Type -->
                <h5 class="role-model-type"><strong>{{ role.user.position }} Role Model</strong></h5>

                <!-- User Image -->
                <div class="role-model-img">
                  <img :src="role.user.image || defaultImage" alt="User Image" class="role-model-img" />
                </div>

                <!-- Role Model Info -->
                <div class="role-model-info mt-2">
                  <p class="role-model-description">
                    <span v-if="expandedRoleId !== role.id">
                      <span v-html="getShortDescription(role)"></span>
                      <a v-if="shouldShowReadMore(role)" href="#" @click.prevent="toggleReadMore(role)" class="read-more">
                        Read more
                      </a>
                    </span>

                    <span v-else>
                      <span v-html="role.description"></span>
                      <a href="#" @click.prevent="toggleReadMore(null)" class="read-more">Read less</a>
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getRoleModels } from "../../services/api/role-models";

import '../../../sass/dashboard/section-role-models.scss'

export default {
  name: 'RoleModelSection',
  created() {
    this.fetchRoleModels();
  },
  data() {
    return {
      isLoading: false,
      roleModels: [],
      formattedMonth: '',
      defaultImage: 'images/user.png',
      maxDescriptionLength: 300,
      expandedRoleId: null,
    }
  },
  methods: {
    async fetchRoleModels() {
      this.isLoading = true;

      try {
        const response = await getRoleModels();

        if (response.status === 200) {
          this.roleModels = response.data.data;

          if (this.roleModels.length > 0) {
            this.formatMonth(this.roleModels[0].month);
          }
        }
      } catch (error) {
        console.error('Error fetching role models:', error);
      } finally {
        this.isLoading = false;
      }
    },
    formatMonth(month) {
      const [year, m] = month.split('-');
      this.formattedMonth = new Date(year, m - 1).toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
    },
    getShortDescription(role) {
      const maxLength = this.maxDescriptionLength;
      const textContent = this.stripHtmlTags(role.description);
      let finalHtml = "";
      let charCount = 0;

      if (textContent.length <= maxLength) {
        return role.description;
      }

      let tempDiv = document.createElement("div");
      tempDiv.innerHTML = role.description;

      function traverseNodes(node) {
        if (charCount >= maxLength) return;

        if (node.nodeType === Node.TEXT_NODE) {
          let remaining = maxLength - charCount;

          finalHtml += node.textContent.substring(0, remaining);
          charCount += node.textContent.length;
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          // Get the opening and closing HTML tags for the element
          let openTag = `<${node.tagName.toLowerCase()}${getAttributes(node)}>`;
          let closeTag = `</${node.tagName.toLowerCase()}>`;

          finalHtml += openTag;
          node.childNodes.forEach(child => traverseNodes(child));
          finalHtml += closeTag;
        }
      }

      function getAttributes(node) {
        return Array.from(node.attributes).map(attr => ` ${attr.name}="${attr.value}"`).join("");
      }

      traverseNodes(tempDiv);

      return finalHtml;
    },
    shouldShowReadMore(role) {
      return this.stripHtmlTags(role.description).length > this.maxDescriptionLength;
    },
    toggleReadMore(role) {
      if (role) {
        this.expandedRoleId = role.id;
      } else {
        this.expandedRoleId = null;
      }
    },
    stripHtmlTags(html) {
      const div = document.createElement("div");
      div.innerHTML = html;

      return div.textContent.trim();
    }
  }
}
</script>